import { IGetUserDetailResponse } from '../../..';
import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'hr', controller: 'Users') => ({
	Insert: new PostMethod<any, any>({
		service,
		controller,
		method: 'Insert'
	}),
	Update: new PostMethod<boolean, any>({
		service,
		controller,
		method: 'Update'
	}),
	GetUserProfileImageDownloadUrl: new GetMethod<string, null>({
		service,
		controller,
		method: 'GetUserProfileImageDownloadUrl'
	}),
	GetUserDetail: new GetMethod<IGetUserDetailResponse, null>({
		service,
		controller,
		method: 'GetUserDetail'
	}),
	Get: new PostMethod<any, any>({
		service,
		controller,
		method: 'Get'
	}),
	GetUserProfileImageUploadUrl: new GetMethod<any, any>({
		service,
		controller,
		method: 'GetUserProfileImageUploadUrl'
	}),
	GetAutocompleteUsers: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAutocompleteUsers'
	}),
	GetAllWithLoadOptions: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetAllWithLoadOptions'
	}),
	GetUsersProfileImage: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetUsersProfileImage'
	}),
	GetUserPropertyValue: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetUserPropertyValue'
	}),
	UpdateUserMfaEnabled: new PostMethod<boolean, { value: boolean }>({
		service,
		controller,
		method: 'UpdateUserMfaEnabled'
	}),
	UpdateUserTheme: new PostMethod<{ theme: any }, { theme: any }>({
		service,
		controller,
		method: 'UpdateUserTheme'
	}),
	GetWithForeignKeyNames: new PostMethod<any, { id: number }>({
		service,
		controller,
		method: 'GetWithForeignKeyNames'
	}),
	GetConfig: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetConfig'
	})
});

export { getMethods };
